<template>
  <div class="field">
    <label :class="getClass ? 'req': ''" class="required">{{ label }}</label>
    <input
        @focus="isFocused=true"
        @blur="isFocused=false; updateServerValue($event.target.value)"
        :disabled="isDataUpdating"
        :value="currentDataFormated"
        @change="updateServerValue($event.target.value)"
        type="date">
  </div>
</template>

<script>
import 'moment-timezone';
import moment from "moment";
//@change="$emit('onChange', $event.target.value);"
// this.$parent.saveData();
//import axios from "axios";
export default {
  name: "DataInput2.vue",
  props: [
    'modelValue',
    'keyData',
    'label',
    'topLevel',
    'isDataUpdating'
  ],
  data() {
    return {
      isFocused: false
    }
  },
  methods: {
    updateServerValue(value) {
      if (!this.isFocused) {
        this.$emit('update:modelValue', value);
        this.$emit('onChange');
        if (typeof this.$parent.saveData === 'function') {
          this.$parent.saveData();
				}
      }
    },
		getClass() {
      if (typeof this.$parent.isFieldRequired === 'function') {
        return this.$parent.isFieldRequired(this.keyData)
      }
      else {return false}
		}
  },
  computed: {
    currentDataFormated() {
      return moment(this.modelValue).format('YYYY-MM-DD')
    }
  }
}
</script>

<style scoped>

</style>